<template>
  <div class="royaltyMain">


    <div class="search-form">

      <div class="select-box" @click="showPlotPicker = true">
        <div class="show-item">
          <div class="name">{{ plotName }}</div>
          <img class="icon" src="@/assets/image/icon/lower.png">
        </div>
      </div>

    </div>

    <div class="search-form">

      <div class="select-box" @click="showTimePicker = true">
        <div class="show-item">
          <div class="name">{{ timeShow }}</div>
          <img class="icon" src="@/assets/image/mine/index/manage-image_2.png">
        </div>
      </div>

    </div>

    <div class="count-box">

      <div class="count-item" style="margin-left: 0">
        <div class="label">订单总金额(元)</div>
        <div class="info">
          <div class="value">{{ orderGold }}</div>
        </div>
      </div>

      <div class="count-item" style="margin-right: 0">
        <div class="label">分成方式</div>
        <div class="info">
          <div class="value">{{ sharingType }}</div>
        </div>
      </div>

      <div class="count-item" style="margin-left: 0">
        <div class="label">总充电费(元)</div>
        <div class="info">
          <div class="value">{{ chargeFee }}</div>
        </div>
      </div>
      <div class="count-item" style="margin-right: 0">
        <div class="label">总服务费(元)</div>
        <div class="info">
          <div class="value">{{ serviceFee }}</div>
        </div>
      </div>

      <div class="count-item" style="margin-left: 0">
        <div class="label">总分成金额(元)</div>
        <div class="info">
          <div class="value">{{ totalAmount }}</div>
        </div>
      </div>

      <div class="count-item" style="margin-right: 0">
        <div class="label">我的分成金额(元)</div>
        <div class="info">
          <div class="value">{{ myAmount }}</div>
        </div>
      </div>

      <div class="count-item" style="margin-left: 0" v-if="operatorType === 1">
        <div class="label">平台分成金额(元)</div>
        <div class="info">
          <div class="value">{{ platformAmount }}</div>
        </div>
      </div>
      <div class="count-item" style="margin-right: 0" v-if="operatorType === 1">
        <div class="label">分成者分成金额(元)</div>
        <div class="info">
          <div class="value">{{ shareholderAmount }}</div>
        </div>
      </div>

    </div>

    <nut-picker
        :is-visible="showPlotPicker"
        :list-data="plotOptions"
        @close="closePlotPicker"
        @confirm="confirmPlotPicker"
    ></nut-picker>

    <van-calendar
        v-model="showTimePicker"
        color="#134FC5"
        type="range"
        :min-date="minDate"
        :max-date="maxDate"
        @close="showTimePicker = false"
        @confirm="confirmTimePicker"
    />

  </div>

</template>

<script>
import { getPlotListForOperator, getRoyaltySummary} from "@/api/newApi";

import { Toast } from "vant";
import {formatDate} from "@/utils/formart";
export default {
  data() {
    return {
      plotName: "全部站点",
      timeShow: "全部时间",
      plotId: null,
      showPlotPicker: false,
      showTimePicker: false,
      plotOptions: [],
      startTime: '',
      endTime: '',
      orderGold: 0,
      chargeFee: 0,
      serviceFee: 0,
      sharingType: '',
      totalAmount: 0,
      platformAmount: 0,
      operatorAmount: 0,
      shareholderAmount: 0,
      myAmount: 0,
      operatorType: 0,

      minDate: new Date(2022, 0, 1),
      maxDate: new Date(),
    };
  },
  mounted() {
    this.getRoyaltySummary();
    this.getPlotList();
  },
  methods: {

    getRoyaltySummary() {

      this.orderGold = 0;
      this.chargeFee = 0;
      this.serviceFee = 0;

      this.totalAmount = 0;
      this.platformAmount = 0;
      this.operatorAmount = 0;
      this.shareholderAmount = 0;
      this.operatorType = 0;
      this.myAmount = 0;
      this.sharingType = '';

      let params = { plotId: this.plotId, startTime: this.startTime, endTime: this.endTime };

      getRoyaltySummary(params).then((res) => {
        if (res.message.status === 200 && res.data != null) {
          this.orderGold = res.data.orderGold;
          this.chargeFee = res.data.chargeFee;
          this.serviceFee = res.data.serviceFee;

          this.totalAmount = res.data.totalAmount;
          this.platformAmount = res.data.platformAmount;
          this.operatorAmount = res.data.operatorAmount;
          this.shareholderAmount = res.data.shareholderAmount;
          this.operatorType = res.data.operatorType;

          if(this.operatorType === 1){
            this.myAmount = res.data.operatorAmount;
          } else if(this.operatorType === 2) {
            this.myAmount = res.data.shareholderAmount;
          }

          if(res.data.sharingType === 1) {
            this.sharingType = '电费';
          } else if(res.data.sharingType === 2) {
            this.sharingType = '服务费';
          } else if(res.data.sharingType === 3) {
            this.sharingType = '电费+服务费';
          }

        } else {
          Toast("暂无数据！");
        }
      });
    },

    getPlotList() {
      let params = {pageNo: 1, pageSize: 100, deviceType: 4};
      this.plotOptions = [];
      getPlotListForOperator(params).then((res) => {
        if (res.data != "") {
          if (res.message.code == 0) {
            let list = res.data.records.map((item) => {
              return {
                label: item.id,
                value: item.plotName,
              };
            });
            list.unshift({
              label: "",
              value: "全部站点",
            });
            this.plotOptions = [list];
          }
        } else {
          Toast("暂无数据");
        }
      });
    },
    closePlotPicker() {
      this.showPlotPicker = false;
    },
    confirmPlotPicker(even) {
      this.plotName = even[0].value;
      this.plotId = even[0].label;
      this.closePlotPicker();
      this.getRoyaltySummary();
    },
    confirmTimePicker(e) {
      this.startTime = formatDate(e[0], "yyyy-MM-dd");
      this.endTime = formatDate(e[1], "yyyy-MM-dd");
      this.timeShow = this.startTime + " - " + this.endTime;
      this.showTimePicker = false;
      this.getRoyaltySummary();
    },

  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/sass/state.scss";

.royaltyMain {

  min-height: calc(100vh - 1.8rem);
  background-color: #F5F5F6;
  position: relative;

  .search-form {
    padding: 0.3rem $divPadding;
    height: 1.684375rem;
    width: 100%;
    box-sizing: border-box;
    background-color: white;


    .search-input_actived {
      transition: all .3s ease;
      background-color: #F5F5F5;
      transform: scale(1.01);
      box-shadow: 0 4px 0.2rem 4px rgba(0, 0, 0, 0.3);
      overflow: hidden;
      position: absolute;
      z-index: 80;
      width: calc(100% - ($divPadding * 2));

      .picker-box {
        transition: all .3s ease;
        background-color: #F5F5F5 !important;
        max-height: 4.5rem;
        height: auto;
      }
    }

    .picker-box {
      width: 100%;
      height: 0;

      overflow: scroll;

      .picker-item {
        padding: 0.3rem;
        position: relative;

        &:before {
          content: '';
          position: absolute;
          width: 95%;
          height: 1px;
          left: 0;
          right: 0;
          bottom: 0;
          margin: 0 auto;
          background-color: #DDDDDD;
        }
      }
    }

    .select-box {
      border-radius: $borderRadius;
      background-color: #F5F5F5;

      .show-item {
        display: flex;
        justify-content: space-between;
        box-sizing: content-box;
        padding: 0.3rem;
      }

      .name,
      .icon {
        align-self: center;
      }

      .name {
        color: #666666;
        font-size: $fontSize_12;
      }

      .icon {
        width: 0.1921rem;
        height: 0.1651rem;
        margin-right: 0.1rem;
      }
    }

  }

  .count-box {

    margin-top: 10px;

    padding: 0.3rem $divPadding;
    height: 1.684375rem;
    width: 100%;
    box-sizing: border-box;
    //background-color: white;


    display: flex;
    flex-wrap: wrap;

    .count-header {
      padding: 0.5rem 0.3rem !important;
    }

    .count-item,
    .count-header {
      padding: 0.3rem 0.3rem;
      padding-bottom: 0.2rem;
      border-radius: 0.15rem;
      width: 48%;
      margin: 0.4267rem 2%;
      margin-bottom: 0;
    }

    .count-item {
      // background: linear-gradient(112deg, #BFD9FF, #E9F3FF);
      background: #FFFFFF;

      .label {
        color: #666666;
        font-size: 0.34rem;
      }

      .info {
        margin-top: 0.2rem;
        display: flex;
        justify-content: space-between;

        .value {
          font-size: 0.44rem;
          font-weight: bold;
          color: #444444;
        }

        .operate {
          display: flex;
          font-size: 0.33rem;
          align-self: center;

          .text {
            color: #4D77EF;
          }

          .text, .icon-box {
            align-self: center;
          }
        }
      }
    }

    .count-header {
      display: flex;

      .info {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        color: white;

        .label {
          font-size: 0.3273rem;
        }

        .value {
          font-size: 0.4973rem;
          font-weight: bold;
        }
      }

      .header-icon {
        width: 1.1rem;
        height: 1.1rem;
        align-self: center;
      }

      &:nth-child(1) {
        background: linear-gradient(112deg, #FD6D00, #FE8F21);
      }

      &:nth-child(2) {
        background: linear-gradient(112deg, #4D77EF, #6A8DF1);
      }
    }
  }


  // 以上是新样式

  .info-box-length {
    margin: 0.2778rem 0.3467rem;
    font-size: 0.3733rem;
    color: #000000;
  }

  .equip-list-box {
    .equip-item {
      margin-bottom: 0.2367rem;
      background: #ffffff;
      border-radius: 0.1867rem;
      padding: 0.32rem;

      .item-title-box {
        display: flex;
        align-items: center;
        justify-content: space-between;

        img {
          width: 0.3733rem;
          height: 0.3733rem;
        }

        span {
          margin-right: 0.2667rem;
          font-size: 0.4267rem;
          font-weight: 600;
          color: #000000;
        }

        .status {
          font-size: 0.32rem;
        }
      }

      .item-center-box {
        margin-top: 0.2667rem;
        padding: 0.32rem 0.5867rem;
        background: #f5f5f5;
        border-radius: 0.1867rem;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;

        .center-info {
          width: 50%;
          font-size: 0.4rem;
          color: #666666;
          line-height: 0.5867rem;
        }
      }

      .item-bottom-box {
        margin-top: 0.2667rem;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .btn-box {
          width: 1.8933rem;
          height: 0.7467rem;
          text-align: center;
          line-height: 0.7467rem;
          border: 1px solid #134fc5;
          border-radius: 0.3467rem;
          font-size: 0.32rem;
          color: #3961b2;
        }
      }
    }
  }

}
</style>
